import { render } from "./TsrAttachments.vue?vue&type=template&id=9b4ad682&scoped=true"
import script from "./TsrAttachments.vue?vue&type=script&lang=js"
export * from "./TsrAttachments.vue?vue&type=script&lang=js"

import "./TsrAttachments.vue?vue&type=style&index=0&id=9b4ad682&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4ad682"]])

export default __exports__